import { LockedScreen } from "./components/common/LockedScreen";
import { EducationScreen } from "./screens/education/EducationScreen";
import { SignalsScreen } from "./screens/signals/SignalsScreen";
import { LiveChartsScreen } from "./screens/live-charts/LiveChartsScreen";
import { ScannerScreen } from "./screens/scanner/ScannerScreen";
import { ProfileScreen } from "./screens/profile/ProfileScreen";
import { CopyTradingScreen } from "./screens/copytrading/CopyTradingScreen";

/* Router between the tabs. Each tab is gated by accessibleSections
   (see access/sectionAccess.js) — locked tabs render LockedScreen
   instead of the real screen. */
export function Screens({
  tab,
  setTab,
  t,
  lang,
  setLang,
  wide,
  user,
  stats,
  authFetch,
  token,
  accessibleSections,
  lockReason,
  activeSignal,
  activeScan,
  requestTelegramLinkCode,
  setPassword,
  linkEmail,
  onLogout,
  trialRenewalStatus,
  trialRenewalError,
  submitTrialRenewal,
  resetTrialRenewal,
}) {
  const goProfile = () => setTab("profile");
  const renderSection = (key, node) =>
    accessibleSections.has(key) ? (
      node
    ) : (
      <LockedScreen
        t={t}
        wide={wide}
        reason={lockReason}
        onGoProfile={goProfile}
        trialRenewalStatus={trialRenewalStatus}
        trialRenewalError={trialRenewalError}
        onSubmitTrialRenewal={submitTrialRenewal}
        onResetTrialRenewal={resetTrialRenewal}
      />
    );

  return (
    <>
      {tab === "edu" && renderSection("edu", <EducationScreen t={t} lang={lang} wide={wide} user={user} authFetch={authFetch} />)}
      {tab === "signals" && renderSection("signals", <SignalsScreen t={t} wide={wide} activeSignal={activeSignal} />)}
      {/* {tab === "live" && renderSection("live", <LiveChartsScreen t={t} lang={lang} wide={wide} authFetch={authFetch} token={token} />)} */}
      {tab === "scanner" && renderSection("scanner", <ScannerScreen t={t} wide={wide} activeScan={activeScan} />)}
      {tab === "copytrading" && renderSection("copytrading", <CopyTradingScreen t={t} lang={lang} wide={wide} />)}
      {tab === "profile" && (
        <ProfileScreen
          t={t}
          lang={lang}
          setLang={setLang}
          wide={wide}
          user={user}
          stats={stats}
          authFetch={authFetch}
          requestTelegramLinkCode={requestTelegramLinkCode}
          setPassword={setPassword}
          linkEmail={linkEmail}
          onLogout={onLogout}
        />
      )}
    </>
  );
}
